/*
 * Entrada do chat no pacote principal: só a checagem da opção e o que precisa
 * existir mesmo com o chat fora do alcance do leitor (os tipos de notificação
 * nas configurações). O store, a gaveta e a barra lateral moram no chunk
 * `runtime`, pedido antes do primeiro desenho quando o chat está ligado para
 * o leitor; com o chat desligado no admin, nada do chat é baixado.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import { lazyComponent } from '../../utils/lazy';
import { caps, chatOn, ct } from './flags';
let runtime = null;
function loadRuntime() {
  runtime ||= import(/* webpackChunkName: 'forum/features/chat/runtime', webpackMode: 'lazy-once' */ './runtime').then(mod => mod.default, error => {
    runtime = null;
    throw error;
  });
  return runtime;
}

// Até o chunk chegar, o mesmo botão sem o indicador de não lidas: o cabeçalho
// não muda de largura quando o ícone de verdade entra.
const ChatHeaderIcon = lazyComponent(() => loadRuntime().then(r => r.ChatHeaderIcon), () => m("a", {
  className: "Button Button--flat Button--icon icon chat-header-icon__button",
  href: app.route('canela.chat'),
  title: ct('open'),
  "aria-label": ct('open')
}, m(Icon, {
  name: "far fa-message"
})));

/**
 * Apaga os rascunhos do chat que não são de quem está logado agora: depois de
 * sair (ou trocar de conta), as MDs não escritas não ficam no navegador.
 */
function forgetOtherDrafts() {
  try {
    const mine = `canela.chat.draft.${app.session.user?.id() || 0}.`;
    const stale = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('canela.chat.draft.') && !key.startsWith(mine)) stale.push(key);
    }
    stale.forEach(key => localStorage.removeItem(key));
  } catch {
    // Sem armazenamento: não há o que apagar.
  }
}
export default function installChat() {
  // O pedido sai antes do primeiro desenho; a gaveta e o resto ligam quando ele chega.
  app.beforeMount(() => {
    forgetOtherDrafts();
    if (chatOn()) loadRuntime().then(r => r.start());
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!chatOn()) return;
    items.add('canelaChat', m(ChatHeaderIcon, null), 15);
  });
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    if (!caps().enabled || !caps().allowed) return;
    items.add('canelaChatMention', {
      name: 'canelaChatMention',
      icon: 'fas fa-at',
      label: ct('notifications.settings_mention')
    });
    items.add('canelaChatMessage', {
      name: 'canelaChatMessage',
      icon: 'far fa-message',
      label: ct('notifications.settings_message')
    });
  });
  extend(UserControls, 'userControls', function (items, ...args) {
    const user = args[0];
    const me = app.session.user;
    if (!chatOn() || !caps().canDirectMessage || !me || !user || user === me) return;

    // Com o flarum/messages, as mensagens privadas já têm a própria entrada
    // ("Enviar mensagem"): uma segunda, para a MD do chat, só confundiria.
    if ('flarum-messages' in flarum.extensions) return;
    items.add('canelaChat', m(Button, {
      icon: "far fa-message",
      onclick: () => loadRuntime().then(r => r.openDirect(user))
    }, ct('title_capitalized')), 90);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/chat', installChat);flarum.reg.addChunkModule('forum/features/chat/runtime', './src/forum/features/chat/runtime.tsx', 'ramon-canela', 'forum/features/chat/runtime');
flarum.reg.addChunkModule('forum/features/chat/runtime', './src/forum/features/chat/runtime.tsx', 'ramon-canela', 'forum/features/chat/components/ChatDrawer');
flarum.reg.addChunkModule('forum/features/chat/runtime', './src/forum/features/chat/runtime.tsx', 'ramon-canela', 'forum/features/chat/components/ChatHeaderIcon');
flarum.reg.addChunkModule('forum/features/chat/runtime', './src/forum/features/chat/runtime.tsx', 'ramon-canela', 'forum/features/chat/sidebar');
flarum.reg.addChunkModule('forum/features/chat/runtime', './src/forum/features/chat/runtime.tsx', 'ramon-canela', 'forum/features/chat/preferences');